import { companyPartialUpdaterBuilder } from "../companyPartialUpdaterBuilder";
import {
  CompanyVatNumberFormik,
  COMPANY_VAT_NUMBER_FORM_MESSENGER_CONTEXT,
  validationCompanyVatNumberSchema,
} from "./CompanyVatNumberForm";

export const CompanyVatNumberEdit = companyPartialUpdaterBuilder(CompanyVatNumberFormik, {
  validationSchema: validationCompanyVatNumberSchema,
  messengerContext: COMPANY_VAT_NUMBER_FORM_MESSENGER_CONTEXT,
});
